export const student = {
    name: 'Петров Петр Петрович',
    previousName: 'Иванов Петр Петрович',
    id: '12',
    faculty: 'Прикладная информатика',
    course: 'AA - 1Б',
    group: 'IT2041',
    isExcluded: false,
    login: 'petrov1996',
    spec: '09.04.02 Информационные системы и технологии',
    studyStartDate: '01.09.2020',
    studyEndDate: '',
    averageRate: 3.69,
};
